<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="PRODUTOS" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} "
            image-title="assets/img/limited-stock.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/produtos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="project-tab">
        <div class="form-row">
          <div class="col-md-12">
            <ul class="nav nav-tabs" role="tablist" style="font-size: 13px;">
              <li class="nav-item">
                <a class="nav-link active" id="principal-tab" data-toggle="tab" href="#principal" role="tab"
                  aria-controls="principal" aria-selected="true">Dados do Produto</a>
              </li>
              <li class="nav-item" *ngIf="entidade.medicamento?.id || entidade.material?.sub_grupo?.grupo?.medicamento">
                <a class="nav-link" id="medicamento-tab" data-toggle="tab" href="#medicamento" role="tab"
                  aria-controls="medicamento" aria-selected="true">Dados de Medicamento</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="unidade-tab" data-toggle="tab" href="#unidade" role="tab"
                  aria-controls="unidade" aria-selected="true">Unidades de fornecimento</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="referencia-tab" data-toggle="tab" href="#referencia" role="tab"
                  aria-controls="referencia" aria-selected="true">Referências</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="saldo-tab" data-toggle="tab" href="#saldo" role="tab" aria-controls="saldo"
                  aria-selected="true">Saldo Almoxarifado</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="saldo-setor-tab" data-toggle="tab" href="#saldo-setor" role="tab"
                  aria-controls="saldo-setor" aria-selected="true">Saldo Setor</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="favorecido-tab" data-toggle="tab" href="#favorecido" role="tab"
                  aria-controls="favorecido" aria-selected="true">Catálogo de Favorecidos</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="principal" role="tabpanel" aria-labelledby="principal-tab">
                <div class="form-row pt-3">
                  <div class="col-sm-8 mb-3 pl-3">
                    <div class="form-row">
                      <div class="form-group col-md-3">
                        <div class="d-flex justify-content-between">
                          <label for="codigo">Código<span class="text-danger">*</span></label>
                          <span class="text-primary">#{{visualizaCodigo()}}</span>
                        </div>
                        <input #codigo_ id="codigo" formControlName="codigo" type="text" class="form-control">
                      </div>
                      <div class="form-group col-md-9">
                        <label for="nome">Nome<span class="text-danger">*</span></label>
                        <input id="nome" formControlName="nome" type="text" class="form-control font-weight-bold">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12 mb-0">
                        <label for="material">Grupo de Material<span class="text-danger">*</span></label>
                        <p-autoComplete formControlName="material" [field]="materialAutoComplete.conversor"
                          [suggestions]="materialAutoComplete.lista"
                          (completeMethod)="materialAutoComplete.filtrar($event)"
                          placeholder="Informe o nome do Grupo de material"
                          inputStyleClass="form-control font-weight-bold" minLength="2"
                          [style]="{ width: 'calc(100% - 40px)' }" [forceSelection]="true" [autoHighlight]="true"
                          *ngIf="materialAutoComplete" (onSelect)="selectMaterial()">
                          <ng-template let-material pTemplate="item">
                            {{material.codigo}} {{material.nome}}
                          </ng-template>
                        </p-autoComplete>
                        <button class="btn btn-outline-secondary float-right" type="button" data-toggle="modal"
                          style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;"
                          (click)="visualizarGrupo=true">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div class="form-row mb-3">
                      <div class="col-sm-12 d-flex justify-content-between">
                        <span *ngIf="entidadeForm.get('material').value" style="color: #ef5000"
                          class="font-weight-bold small mt-2 mb-0">
                          {{ entidadeForm.get('material').value['sub_grupo']['nome'] }}
                        </span>
                        <span *ngIf="entidadeForm.get('material').value" style="color: #ef6c00"
                          class="font-weight-bold small mt-2 mb-0 text-right">
                          {{ entidadeForm.get('material').value['sub_grupo']['grupo']['nome'] }}
                        </span>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="material">Localização</label>
                        <p-autoComplete formControlName="localizacao" [field]="localizacaoAutoComplete.conversor"
                          [suggestions]="localizacaoAutoComplete.lista"
                          (completeMethod)="localizacaoAutoComplete.filtrar($event)" placeholder="Informe a localização"
                          inputStyleClass="form-control font-weight-bold" minLength="2"
                          [style]="{ width: 'calc(100% - 40px)', float: 'left' }" [forceSelection]="true"
                          [autoHighlight]="true" *ngIf="localizacaoAutoComplete">
                          <ng-template let-item pTemplate="item">
                            SALA: {{item.sala}}, ARMÁRIO: {{item.armario}}, PRATILEIRA: {{item.prateleira}}
                          </ng-template>
                        </p-autoComplete>
                        <button class="btn btn-outline-secondary float-right" type="button" (click)="visualizarLocalizacao=true"
                          style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12 mb-0">
                        <label for="descricao">Descrição<span class="text-danger">*</span></label>
                        <textarea id="descricao" formControlName="descricao" type="text" style="min-height: 180px;"
                          class="form-control"> </textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-row pl-3 mt-2">
                      <div class="col-sm-11 offset-1">
                        <div class="card p-1">
                          <ul class="list-group list-group-flush">
                            <li class="list-group-item">
                              <div class="checkbox checbox-switch switch-success">
                                <label>
                                  <input type="checkbox" formControlName="bec" disabled /><span></span>Bolsa eletrônica
                                  de compra
                                </label>
                              </div>
                            </li>
                            <li class="list-group-item">
                              <div class="checkbox checbox-switch switch-primary">
                                <label style="margin: 0; text-align: left;">
                                  <input type="checkbox" formControlName="inativo" /><span></span>Inativo
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="form-row pl-3 mt-2">
                      <div class="col-sm-11 offset-1">
                        <div class="card p-3">
                          <div class="form-row">
                            <div class="form-group col-md-12">
                              <label for="financeiro_min">Cota Financeira Mínima</label>
                              <input unmask="typed" [imask]="imaskValor" formControlName="financeiro_min" type="text"
                                class="form-control text-right font-weight-bold" id="financeiro_min" placeholder="0,00">
                            </div>
                            <div class="form-group col-md-12">
                              <label for="financeiro_max">Cota Financeira Máxima</label>
                              <input unmask="typed" [imask]="imaskValor" formControlName="financeiro_max" type="text"
                                class="form-control text-right font-weight-bold" id="financeiro_max" placeholder="0,00">
                            </div>
                          </div>
                          <div class="form-row mt-3">
                            <div class="form-group col-md-12">
                              <label for="estoque_min">Cota Quantitativa Mínima</label>
                              <input formControlName="estoque_min" type="text" [imask]="imaskValor" unmask="typed"
                                class="form-control text-right font-weight-bold" id="estoque_min" placeholder="0">
                            </div>
                            <div class="form-group col-md-12 mb-0">
                              <label for="estoque_max">Cota Quantitativa Máxima</label>
                              <input unmask="typed" [imask]="imaskValor" formControlName="estoque_max" type="text"
                                class="form-control text-right font-weight-bold" id="estoque_max" placeholder="0">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="medicamento" role="tabpanel" aria-labelledby="medicamento-tab"
                *ngIf="entidade.medicamento?.id || entidade.material?.sub_grupo?.grupo?.medicamento">
                <lib-produto-medicamento [(entidade)]="entidade" [login]="login">
                </lib-produto-medicamento>
              </div>
              <div class="tab-pane fade" id="unidade" role="tabpanel" aria-labelledby="unidade-tab">
                <lib-produto-unidade [(lista)]="unidades" [(entidade)]="entidade" [login]="login">
                </lib-produto-unidade>
              </div>
              <div class="tab-pane fade" id="referencia" role="tabpanel" aria-labelledby="referencia-tab">
                <lib-referencia-unidade [(lista)]="referencias" [(entidade)]="entidade" [login]="login">
                </lib-referencia-unidade>
              </div>
              <div class="tab-pane fade" id="saldo" role="tabpanel" aria-labelledby="saldo-tab">
                <lib-produto-saldo-estoque [(produto)]="entidade" [login]="login">
                </lib-produto-saldo-estoque>
              </div>
              <div class="tab-pane fade" id="saldo-setor" role="tabpanel" aria-labelledby="saldo-setor-tab">
                <lib-produto-saldo-setor [(produto)]="entidade" [login]="login">
                </lib-produto-saldo-setor>
              </div>
              <div class="tab-pane fade" id="favorecido" role="tabpanel" aria-labelledby="favorecido-tab">
                <lib-produto-favorecido [(lista)]="favorecidos" [login]="login">
                </lib-produto-favorecido>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-2 mb-4" />
      <div class="row">
        <div class="col-12">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>
<lib-produto-localizacao-form-dlg [(visualizar)]="visualizarLocalizacao" [entidade]="entidadeForm.get('localizacao').value"
  (entidadeChange)="selecionarLocalizacao($event)"></lib-produto-localizacao-form-dlg>
<lib-material-form-dlg [(visualizar)]="visualizarGrupo" [entidade]="entidadeForm.get('material').value"
  (entidadeChange)="selecionarMaterial($event)"></lib-material-form-dlg>